export const PRIMARY_BUTTON_COLOR = "#504998";

export const DANGER_BUTTON_COLOR = "#dc3545";

export const icons = {
    warning: "warning",
    question: "question",
    success: "success",
    error: "error",
    info: "info",
};
